import axios from "axios";

export default {
  namespaced: true,
  state: {
    coachsData: null
  },
  mutations: {
    setCoachsData(state, data) {
      state.coachsData = data;
    }
  },
  actions: {
    async fetchCoachsData({ state, commit }) {
      if (state.coachsData) return state.coachsData;
      const response = await axios.get("/api/games/coachs/getWinsAndLossesByCoach");
      commit("setCoachsData", response.data);
      return response.data;
    }
  }
}